/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AutofaxMessage = {
    readonly id?: number;
    fax_integration?: number | null;
    fax_number: string;
    /**
     * current status of the fax transmission
     */
    status: AutofaxMessage.status;
    readonly created_at?: string;
    readonly clinic_name?: string;
}

export namespace AutofaxMessage {

    /**
     * current status of the fax transmission
     */
    export enum status {
        PROCESSING = 'processing',
        WAITING = 'waiting',
        SUCCESS = 'success',
        ERROR = 'error',
        HOLD = 'hold',
    }


}
